import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import authEn from './locales/en/auth.json';
import billingEn from './locales/en/billing.json';
import commonEn from './locales/en/common.json';
import authSv from './locales/sv/auth.json';
import billingSv from './locales/sv/billing.json';
import commonSv from './locales/sv/common.json';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './types';
let initStarted = false;
export function initI18n() {
    if (i18n.isInitialized || initStarted)
        return i18n;
    initStarted = true;
    void i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
        resources: {
            en: {
                common: commonEn,
                auth: authEn,
                billing: billingEn,
            },
            sv: {
                common: commonSv,
                auth: authSv,
                billing: billingSv,
            },
        },
        fallbackLng: DEFAULT_LANGUAGE,
        supportedLngs: [...SUPPORTED_LANGUAGES],
        defaultNS: 'common',
        ns: ['common', 'auth', 'billing'],
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['querystring', 'navigator'],
            caches: [],
        },
        initAsync: false,
    });
    return i18n;
}
export { i18n };
